export default __webpack_public_path__ + "static/media/female-unique.e19ed035.svg";